






















import Vue, { PropType } from 'vue';

export default Vue.extend({
    props: {
        cards: {
            type: Array as PropType<any>, // todo: 去掉any
            required: true,
        },
    },
    data() {
        return {
            prevCardsLen: 0, // 上次卡片个数
            scrollListener: null as any,
        };
    },
    mounted() {
        let timer: number; // 节流
        this.scrollListener = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                const rect = (this.$refs.container as Element).getClientRects()[0];
                if (!rect) return;
                // viewportHeight的计算逻辑是网上复制来的
                const viewportHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight || 0;
                if (rect.height + (rect.y || rect.top) - viewportHeight <= 10) { // 10 pixcel就触发
                    if (this.prevCardsLen !== this.cards.length) {
                        this.prevCardsLen = this.cards.length;
                        this.$emit('loadMore');
                    } else { // 所有的加载完毕则清除监听
                        window.removeEventListener('scroll', this.scrollListener);
                    }
                }
            }, 200);
        };
        window.addEventListener('scroll', this.scrollListener);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollListener);
    },
});
